import { css } from '@eti/styles';

export const agesOptionsStyles = (index) => css`
  ${index === 0 && 'border-top: none'};
`;
